import PropTypes from 'prop-types';

import { FadeInAnimation } from '../shared';
import { parseTitle } from '../../../utils/title-parser';


const BestLifeSection = (props) => {    

    return (

        <div className='container-root container-root-maxWidthMd best-life-section-container best-life-section-container-settings'>

            <div className='best-life-section-title'>{parseTitle(props.title, 'best_live_header')}</div>

            <FadeInAnimation>

                <div>

                    <p className='best-life-section-paragraph' id="best_life_paragraph">
                        {props.paragraph}
                    </p>

                </div>
                
            </FadeInAnimation>

        </div>

    );

};

export default BestLifeSection;

BestLifeSection.propTypes = {
    title: PropTypes.string,
    paragraph: PropTypes.string,
};
